import React, { FC } from "react"

type ChipProps = {
  label: string
  color: string
  backgroundColor: string
}

const Chip: FC<ChipProps> = ({ label, color, backgroundColor }) => (
  <span style={{
    color: color,
    backgroundColor: backgroundColor,
    borderRadius: 4,
    padding: "2px 8px",
    fontSize: 12,
  }}
  >
    {label}
  </span>
)

export default Chip
